module.exports = wp.hooks;